<template>
  <div class="sider_1">
    <div class="title">{{ cTagName }}</div>
    <div class="department">
      <ul>
        <li v-for="item in 5" :key="item">
          <a :href="cInfos.link" target="_blank">{{ cInfos.info }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-silder-news",
  components: {},
  props: {
    cTagName: {
      default: "您可能感兴趣的信息",
    },
    cInfos: {
      type: Object,
      default: function () {
        return {
          link: "###",
          info:
            "呼和浩特市地铁2号线成吉思汗广场站主变电所送电成功呼和浩特市地铁2号线成吉思汗广场站主变电所送电成功",
        };
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang='less' scoped>
.fr {
  float: right;
}
.sider_1 {
  width: 350px;
  .title {
    width: 350px;
    height: 24px;
    font-size: 18px;
    padding-bottom: 10px;
  }
  .department {
    width: 330px;
    margin-left: 20px;
    margin-bottom: 30px;
    ul {
      margin: 0;
      padding: 0;
      overflow: hidden;

      li {
        display: inline-block;
        width: 330px;
        height: 24px;
        font-size: 14px;
        line-height: 24px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        a {
          color: #333;
        }
      }
      li:hover {
        background-color: rgb(238, 238, 238);
        a {
          font-weight: bold;
        }
      }
    }
    .ulUp {
      height: 140px;
    }
    .ulDown {
      height: auto;
    }
  }
}
</style>